(() => {
  if (customElements.get('sn48-mixed-packs')) return;
  class SomnilaMixedPacks extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.busy = false;
      this.forms = Array.from(this.querySelectorAll('[data-sn48-form]'));
      this.money = new Intl.NumberFormat(this.dataset.locale || 'fr-FR', { style: 'currency', currency: this.dataset.currency || 'EUR' });
      this.forms.forEach(form => {
        form.dataset.buttonLabel = form.querySelector('[data-sn48-button-label]').textContent;
        form.addEventListener('change', event => {
          if (event.target.matches('[data-sn48-select]')) this.update(form);
        });
        form.addEventListener('submit', event => this.submit(event, form));
        this.update(form);
      });
    }
    update(form) {
      let total = 0;
      let available = true;
      form.querySelectorAll('[data-sn48-select]').forEach(select => {
        const selected = select.selectedOptions[0];
        if (!selected || selected.disabled) available = false;
        total += Number(selected?.dataset.price || 0);
        const image = select.closest('[data-sn48-component]').querySelector('[data-sn48-image]');
        const source = selected?.dataset.image || '';
        if (source && image.getAttribute('src') !== source) image.src = source;
        image.hidden = !source;
        image.alt = this.dataset.imageLabel.replace('[product]', select.dataset.productTitle).replace('[colour]', selected?.dataset.colour || '');
      });
      const saving = this.dataset.currency === 'EUR' ? Number(form.dataset.packSaving || 0) : 0;
      form.querySelector('[data-sn48-total]').textContent = this.money.format(Math.max(0, total - saving) / 100);
      const separate = form.querySelector('[data-sn48-separate]');
      if (separate) separate.textContent = this.money.format(total / 100);
      form.querySelector('[data-sn48-submit]').disabled = this.busy || !available || form.dataset.uncertain === 'true';
      form.dataset.available = String(available);
    }
    setBusy(form, busy) {
      this.busy = busy;
      this.forms.forEach(item => {
        item.querySelector('fieldset').disabled = busy;
        this.update(item);
      });
      form.setAttribute('aria-busy', String(busy));
      form.querySelector('[data-sn48-button-label]').textContent = busy ? this.dataset.adding : form.dataset.buttonLabel;
    }
    async submit(event, form) {
      if (!window.fetch) return;
      const coordinator = window.Sn84CartState;
      if (coordinator?.guardAdd(form, event)) return;
      event.preventDefault();
      if (this.busy || form.dataset.uncertain === 'true') return;
      const error = form.querySelector('[data-sn48-error]');
      const feedback = form.querySelector('[data-sn48-feedback]');
      const cartLink = form.querySelector('[data-sn48-cart-link]');
      error.hidden = true;
      feedback.textContent = '';
      cartLink.hidden = true;
      if (form.dataset.available !== 'true' || !form.reportValidity()) {
        error.textContent = this.dataset.unavailable;
        error.hidden = false;
        return;
      }
      const groupId = `sn48-${form.dataset.packKey}-${window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`}`;
      const properties = { [form.dataset.propertyLabel]: form.dataset.packLabel, _Somnila_pack: form.dataset.packKey, _Somnila_pack_id: groupId };
      const items = Array.from(form.querySelectorAll('[data-sn48-select]'), select => ({ id: select.value, quantity: 1, properties }));
      form.querySelectorAll('[data-sn48-group]').forEach(input => { input.value = groupId; });
      const drawer = document.querySelector('cart-drawer');
      const sections = typeof drawer?.getSectionsToRender === 'function' ? drawer.getSectionsToRender().map(section => section.id) : [];
      const payload = { items };
      if (sections.length) {
        payload.sections = sections;
        payload.sections_url = window.location.pathname;
      }
      const ticket = coordinator?.begin(form, 'purchase');
      if (coordinator && !ticket) return;
      this.setBusy(form, true);
      let confirmed = false;
      let rejected = false;
      try {
        const addUrl = `${form.action.replace(/\.js$/, '')}.js`;
        const options = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify(payload)
        };
        const response = ticket ? await coordinator.add(ticket, addUrl, options) : await fetch(addUrl, options);
        const data = await response.json();
        if (!response.ok || data.status >= 400) {
          rejected = true;
          error.textContent = typeof data.description === 'string' ? `${this.dataset.error} ${data.description}` : this.dataset.error;
          error.hidden = false;
          cartLink.hidden = false;
          return;
        }
        confirmed = true;
        feedback.textContent = this.dataset.added;
        cartLink.hidden = false;
        if (drawer && typeof drawer.renderContents === 'function' && (ticket || sections.every(id => typeof data.sections?.[id] === 'string'))) {
          if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(form.querySelector('[data-sn48-submit]'));
          drawer.classList.remove('is-empty');
          if (ticket) drawer.open();
          else drawer.renderContents({ ...data, id: data.items?.[0]?.id });
        } else {
          window.location.assign(this.dataset.cartUrl);
        }
      } catch {
        if (ticket) {
          if (!ticket.controller.signal.aborted) {
            form.dataset.uncertain = String(Boolean(ticket.uncertain));
            coordinator.showAddError(form, ticket);
            cartLink.hidden = false;
          }
        } else if (confirmed) {
          window.location.assign(this.dataset.cartUrl);
        } else if (!rejected) {
          form.dataset.uncertain = 'true';
          error.textContent = this.dataset.uncertain;
          error.hidden = false;
          cartLink.hidden = false;
        }
      } finally {
        this.setBusy(form, false);
        if (ticket) coordinator.end(ticket);
      }
    }
  }
  customElements.define('sn48-mixed-packs', SomnilaMixedPacks);
})();
